<script>
    import { smartCarMethods } from '@state/helpers'
    import { required, maxLength, minLength } from 'vuelidate/lib/validators'
    
    export default {
      name: 'cardholderForm',
      components: {
      },
      props: {
        instanceJson: {
          type: Object,
          required: false,
          default: () => ({}),
        },
        oncomplete: {
          type: Function,
          required: false,
          default: () => ({}),
        },
        oncancel: {
          type: Function,
          required: false,
          default: () => ({}),
        },
      },
      data() {
        return {
          modalShow: true,
          loading: true,
          submitting: false,
          action: 'create',
          documentOptions: [{value: '1',text: '1'}],
          form: {
            url: null,
            document:0,
            document_type:1,
            bin:null
          },
        }
      },
      validations: {
        form: {
          document: {
            required,
            minLength: minLength(6),
            maxLength: maxLength(20),
          },
          document_type: { required },
          bin: { required,
            minLength: minLength(4),
            maxLength: maxLength(8), 
          },
        },
      },
      computed: {},
      mounted: function () {
        let context = this
        if (context.instanceJson.url) {
          context.action = 'update'
          context.form = {
            ...context.instanceJson,
          }
          context.getObject()
        } else {
          context.action = 'create'
          context.loading = false
        }
      },
    
      methods: {
        ...smartCarMethods,
    
        getObject() {
          let context = this
          if (context.action == 'update') {
            const promise = context.fetchCardholderDetail(context.form.url)
            return promise
              .then((data) => {
                context.form = { ...data }
                context.loading = false
              })
              .catch((error) => {
                context.$axios_error_noty(error, context)
                context.loading = false
              })
          }
        },
        submit() {
          let context = this
          context.submitting = true
          context.$v.form.$touch()
          if (context.$v.form.$invalid) {
            context.submitting = false
            context.$generate_toast(
              context,
              'error',
              'Por favor llene todos los campos requeridos'
            )
            return
          }
          let formEdit = {'cardholders': [context.form]}
          const promise = context.manualCreateEuroSmartCarCardholders(formEdit)
          return promise
            .then((data) => {
              context.$generate_toast(
                context,
                'success',
                `Plantilla ${
                  context.action == 'create' ? 'creada' : 'actualizado'
                } correctamente`
              )
              setTimeout(() => {
                context.oncomplete()
                context.submitting = false
              }, 2000)
            })
            .catch((error) => {
              context.submitting = false
              context.$axios_error_noty(error, context)
            })
        },
      },
    }
    </script>
    
    <template>
      <b-modal
        v-model="modalShow"
        :title="
          action === 'create' ? 'Crear Plantilla' : 'Editar Plantilla'
        "
        :size="action === 'create' ? 'xl' : 'xl'"
        @hidden="oncancel"
        @ok.prevent="submit"
      >
        <b-container class="p-0">
          <b-row v-if="loading">
            <b-col md="12">
              <div class="text-center">
                <b-spinner
                  label="Spinning"
                  style="color: #195db2; width: 4rem; height: 4rem"
                ></b-spinner>
              </div>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col md="12">
              <b-form id="form">
                <form-wrapper :validator="$v.form">
                    <b-row>
                        <b-col md="4">
                            <b-form-group label="Tipo de Documento">
                                <b-form-select
                                v-model="form.document_type"
                                :options="documentOptions"
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <form-group
                                name="document"
                                label="Documento"
                                attribute="Documento"
                            >
                                <b-form-input
                                v-model="form.document"
                                :disabled="true"
                                type="number"
                                slot-scope="{ attrs, listeners }"
                                v-bind="attrs"
                                v-on="listeners"
                                />
                            </form-group>
                        </b-col>
                        <b-col md="4">
                            <form-group
                                name="bin"
                                label="Bin"
                                attribute="Bin"
                            >
                                <b-form-input
                                v-model="form.bin"
                                slot-scope="{ attrs, listeners }"
                                type="number"
                                v-bind="attrs"
                                v-on="listeners"
                                />
                            </form-group>
                        </b-col>
                    </b-row>
                    <div>
                        <form-summary />
                    </div>
                </form-wrapper>
              </b-form>
            </b-col>
          </b-row>
        </b-container>
    
        <template v-slot:modal-footer="{ ok, cancel }">
          <b-button  variant="outline-primary shadow rounded" @click="cancel">
            Cancelar
          </b-button>
    
          <b-button
            variant="primary shadow rounded"
            :class="{ disabled: submitting }"
            @click="ok"
          >
            <b-spinner v-if="submitting" label="Spinning" small></b-spinner>
            <span v-if="submitting"> Guardando </span>
            <span v-else>
              <i class="fe-save"></i>
              Guardar
            </span>
          </b-button>
        </template>
      </b-modal>
    </template>
    <style lang="scss">
    </style>